<form class="flex flex-col gap-6" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex gap-6">
        <app-form-text
            class="flex-1"
            identifier="firstname"
            [label]="'students.add.firstname.label' | translate"
            [placeholder]="'students.add.firstname.placeholder' | translate"
            [control]="form.controls.firstName"
        />
        <app-form-text
            class="flex-1"
            identifier="lastname"
            [label]="'students.add.lastname.label' | translate"
            [placeholder]="'students.add.lastname.placeholder' | translate"
            [control]="form.controls.lastName"
        />
    </div>

    <app-form-text
        identifier="email"
        [label]="'students.add.email.label' | translate"
        [placeholder]="'students.add.email.placeholder' | translate"
        [control]="form.controls.email"
    />

    <app-form-text
        identifier="password"
        [label]="'students.add.password.label' | translate"
        [placeholder]="'students.add.password.placeholder' | translate"
        [control]="form.controls.password"
    />

    <div>
        <legend>{{ 'label.role' | translate }}</legend>
        <div class="flex gap-4">
            <app-form-radio [control]="form.controls.role" value="teacher" [label]="'role.teacher' | translate" name="create.role" identifier="create.role" />
            <app-form-radio [control]="form.controls.role" value="sna" [label]="'role.sna' | translate" name="create.role" identifier="create.role" />
            <app-form-radio [control]="form.controls.role" value="leader" [label]="'role.leader' | translate" name="create.role" identifier="create.role" />
        </div>
    </div>
    <!-- <app-form-text
        identifier="location"
        [label]="'students.add.location.label' | translate"
        [placeholder]="'students.add.location.placeholder' | translate"
        [control]="form.controls.location"
    /> -->

    <!-- TODO: replace with textarea after merge inputs -->
    <app-form-text
        identifier="description"
        [label]="'students.add.description.label' | translate"
        [placeholder]="'students.add.description.placeholder' | translate"
        [control]="form.controls.description"
    />

    <app-form-submit [label]="'students.add.button' | translate" [disabled]="form.disabled" />
</form>
